// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__30EE4","inputWrap":"styles_inputWrap__1QGTG","input":"styles_input__3BMpn"};